function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as s, Fragment as x, jsxs as h } from "react/jsx-runtime";
import * as f from "react";
import { debounce as C } from "./utils/helpers.js";
import { SPACE as I } from "./utils/key-codes.js";
import { useControlProps as N } from "./form-context.js";
import { Text3 as S } from "./text.js";
import V from "./inline.js";
import { useTheme as y, useAriaId as D } from "./hooks.js";
import { getPrefixedDataAttributes as g } from "./utils/dom.js";
import { containerDisabled as E, container as P, disabled as A, checkboxVariants as p, switchCheckboxContainerVariants as j, switchCheckboxLabel as K, barVariants as R, ballVariants as T } from "./switch-component.css-mistica.js";
const $ = (e)=>{
    const { isIos: l  } = y(), o = D(e["aria-labelledby"]), { defaultValue: u , value: d , onChange: a , focusableRef: b , disabled: t  } = N({
        name: e.name,
        value: e.checked,
        defaultValue: e.defaultChecked,
        onChange: e.onChange,
        disabled: e.disabled
    }), [c, k] = f.useState(!!u), r = d !== null && d !== void 0 ? d : c, v = f.useMemo(()=>process.env.NODE_ENV === "test" ? (i)=>a == null ? void 0 : a(i) : C((i)=>{
            a == null || a(i);
        }, 300), [
        a
    ]), n = ()=>{
        d !== void 0 ? a == null || a(!d) : (k(!c), v(!c));
    }, w = (i)=>{
        i.keyCode === I && (i.preventDefault(), i.stopPropagation(), n());
    }, m = /* @__PURE__ */ s("div", {
        className: p[l ? t ? "disabledIos" : "ios" : t ? "disabled" : "default"],
        children: /* @__PURE__ */ s("div", {
            className: j[l ? "ios" : "default"],
            children: /* @__PURE__ */ h("div", {
                className: K,
                children: [
                    /* @__PURE__ */ s("span", {
                        className: R[l ? r ? "checkedIos" : "ios" : r ? "checked" : "default"]
                    }),
                    /* @__PURE__ */ s("span", {
                        className: T[l ? r ? "checkedIos" : "ios" : r ? "checked" : "default"]
                    })
                ]
            })
        })
    });
    return(// When the switch is disabled, it shouldn't be focusable
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    /* @__PURE__ */ s("span", _object_spread_props(_object_spread({
        role: "switch",
        "aria-checked": d !== null && d !== void 0 ? d : c,
        onClick: (i)=>{
            i.stopPropagation(), t || n();
        },
        onKeyDown: t ? void 0 : w,
        tabIndex: t ? void 0 : 0,
        ref: b,
        className: t ? E : P,
        "aria-disabled": t,
        "aria-labelledby": o
    }, g(e.dataAttributes, "Switch")), {
        children: e.render ? /* @__PURE__ */ s(x, {
            children: e.render({
                controlElement: m,
                labelId: o,
                disabled: !!t,
                checked: d !== null && d !== void 0 ? d : c
            })
        }) : /* @__PURE__ */ h(V, {
            space: 16,
            alignItems: "center",
            children: [
                m,
                e.children && /* @__PURE__ */ s(S, {
                    regular: !0,
                    as: "div",
                    id: o,
                    children: /* @__PURE__ */ s("span", {
                        className: t ? A : "",
                        children: e.children
                    })
                })
            ]
        })
    })));
}, H = $;
export { H as default };
